import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { JwtAuthService } from "../services/auth/jwt-auth.service";
import { TOTP_ENROLMENT_REQUIRED, TOTP_ENROLMENT_ROUTE } from "../constants/totp.constants";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private jwtAuth: JwtAuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check for the presence of the 'Skip-Token' header
    if (req.headers.has('Skip-Token')) {
      // Clone the request without the Authorization header
      const reqWithoutToken = req.clone({
        headers: req.headers.delete('Skip-Token')
      });
      return next.handle(reqWithoutToken);
    }

    // Add the Authorization header if a JWT token is present
    const token = this.jwtAuth.getJwtToken();
    const modifiedReq = token
      ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
      : req;

    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Backend forces every other authenticated route into a 403 with this
        // exact message once TOTP enrolment is mandated for the account and not
        // yet completed. verify_tfa and the totp/* routes are exempt, so this
        // never fires from the enrolment screen itself.
        // Several shell calls can 403 concurrently under the hold — only
        // navigate if we're not already there, so each one doesn't queue its
        // own redirect.
        if (
          error.status === 403 &&
          error.error?.message === TOTP_ENROLMENT_REQUIRED &&
          this.router.url !== TOTP_ENROLMENT_ROUTE
        ) {
          this.router.navigateByUrl(TOTP_ENROLMENT_ROUTE);
        }
        return throwError(() => error);
      })
    );
  }
}
